export { default } from './InputControl';